import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function empresasveiculo(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@empresasveiculo/FIND_EMPRESASVEICULO':
      case '@empresasveiculo/UPDATE_EMPRESASVEICULO':
      case '@empresasveiculo/DELETE_EMPRESASVEICULO':
      case '@empresasveiculo/STORE_EMPRESASVEICULO':
      case '@empresasveiculo/EMPRESASVEICULOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@empresasveiculo/SUCCESS_REMOVE':
      case '@empresasveiculo/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@empresasveiculo/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.empresasveiculos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@empresasveiculo/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.empresasveiculo;
        break;
      }

      case '@empresasveiculo/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
